import React from "react"

const help = props => <div>help</div>

export default help



// WEBPACK FOOTER //
// ./src/scenes/Help/pages/help.js